import { configuredAxios } from 'api/configuredAxios';
import { appConstantUrl } from 'appConstant';
import { CustomerDto } from 'api/genTypes/customer';

export const customersAPI = {
  fetchAll: () =>
    configuredAxios
      .get<Array<CustomerDto>>(appConstantUrl.customerUrl)
      .then((result) => result.data),
  create: (c: Omit<CustomerDto, 'id'>) => configuredAxios.post(appConstantUrl.customerUrl, c),
  delete: (c: CustomerDto) => configuredAxios.delete(appConstantUrl.customerUrl + `/${c.id}`),
  update: (c: CustomerDto) => configuredAxios.put(appConstantUrl.customerUrl + `/${c.id}`, c),
};
